import { useDispatch, useSelector } from "react-redux";
import { selectWorldCupResult, simWorldCupResultAgainAsync } from "./WorldCupResultSlice";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from "@mui/material";
import { selectTeam } from "./TeamSlice";

export default function EditTeamDialog(props) {
    const { open, setOpen, dialogData, setDialogData } = { ...props };
    const result = useSelector(selectWorldCupResult);
    const teams = useSelector(selectTeam);
    const dispatch = useDispatch();
    return <Dialog
        open={open}
    >
        <DialogTitle>
            {teams[dialogData.oldCode] && ("Edit/Replace " + teams[dialogData.oldCode].name)}
        </DialogTitle>
        <DialogContent>
            <Stack direction="column" spacing={2} margin="8px">
                <FormControl>
                    <InputLabel>Team</InputLabel>
                    <Select
                        label="Team"
                        value={dialogData.newCode}
                        onChange={e => setDialogData({ ...dialogData, newCode: e.target.value, rating: teams[e.target.value].rating })}
                    >
                        {Object.keys(teams)
                            .filter(k => k !== "loading")
                            .map(k =>
                                <MenuItem value={teams[k].code} key={teams[k].code}>{teams[k].name}</MenuItem>
                            )}
                    </Select>
                </FormControl>
                <TextField
                    label="Rating (0-2500)"
                    value={dialogData.rating}
                    type="number"
                    variant="outlined"
                    onChange={(e) => setDialogData({ ...dialogData, rating: Number.parseInt(e.target.value) })}
                    inputProps={{ min: 0, max: 2500 }}
                />
            </Stack>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={() => setOpen(false)}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        const simAgainRequestBody = createSimAgainRequestBody(result, dialogData);
                        if (simAgainRequestBody) {
                            dispatch(simWorldCupResultAgainAsync(simAgainRequestBody));
                        }
                        setOpen(false);
                    }}
                >
                    Save
                </Button>
            </DialogActions>
        </DialogContent>
    </Dialog>;
}

function createSimAgainRequestBody(result, dialogData) {
    const { oldCode, newCode, rating } = { ...dialogData };
    const sanitizedRating = sanitizeRating(rating);

    const simAgainRequestBody = {
        year: result.year
        , ratings: structuredClone(result.ratings)
        , draw: structuredClone(result.draw)
    }
    if (Number.isInteger(sanitizedRating)) {
        simAgainRequestBody.ratings[newCode] = sanitizedRating;
    }
    const oldIndexes = findIndexesFromDraw(oldCode, result.draw);
    simAgainRequestBody.draw[oldIndexes[0]][oldIndexes[1]] = newCode;

    if (Object.keys(result.ratings).includes(newCode)) {
        const newIndexes = findIndexesFromDraw(newCode, result.draw);
        simAgainRequestBody.draw[newIndexes[0]][newIndexes[1]] = oldCode;
    } else {
        delete simAgainRequestBody.ratings[oldCode];
    }
    return simAgainRequestBody;
}

function sanitizeRating(rating) {
    const parsed = Number.parseInt(rating);
    if (!Number.isInteger(parsed)) {
        return parsed;
    }
    if (parsed < 0) {
        return 0;
    }
    if (parsed > 2500) {
        return 2500;
    }
    return parsed;
}

function findIndexesFromDraw(code, draw) {

    let i, j;
    loop: for (i = 0; i < draw.length; i++) {
        for (j = 0; j < draw[i].length; j++) {
            if (draw[i][j] === code) {
                break loop;
            }
        }
    }
    return [i, j];
}